module.exports = __webpack_public_path__ + "images/Dollar.081a429125520d992bf09c8a13b08c86.svg";